var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('b-row', {
    staticClass: "mb-2"
  }, [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-card', {
    staticClass: "bg-gradient-primary text-white py-1"
  }, [_c('b-row', {
    attrs: {
      "align-v": "center"
    }
  }, [_c('b-col', {
    attrs: {
      "md": "8"
    }
  }, [_c('h1', {
    staticClass: "text-white mb-25 d-flex align-items-center"
  }, [_c('feather-icon', {
    staticClass: "mr-1",
    attrs: {
      "icon": "FileTextIcon",
      "size": "28"
    }
  }), _vm._v(" Relatórios do Sistema ")], 1), _c('p', {
    staticClass: "text-white mb-0",
    staticStyle: {
      "opacity": "0.9"
    }
  }, [_vm._v(" Gere e exporte relatórios consolidados de desempenho, pontuação e engajamento dos estudantes. ")])])], 1)], 1)], 1)], 1), _c('b-card', {
    staticClass: "mb-2",
    attrs: {
      "no-body": ""
    }
  }, [_c('b-card-header', {
    staticClass: "pb-50"
  }, [_c('h4', {
    staticClass: "card-title mb-0 d-flex align-items-center"
  }, [_c('feather-icon', {
    staticClass: "mr-50 text-primary",
    attrs: {
      "icon": "FilterIcon",
      "size": "18"
    }
  }), _vm._v(" Configurações do Relatório ")], 1)]), _c('b-card-body', {
    staticClass: "pt-1"
  }, [_c('b-row', [_c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Tipo de Relatório",
      "label-for": "tipo-relatorio",
      "label-class": "font-weight-bold"
    }
  }, [_c('v-select', {
    attrs: {
      "id": "tipo-relatorio",
      "options": _vm.tiposRelatorio,
      "label": "nome",
      "reduce": function reduce(tipo) {
        return tipo.id;
      },
      "clearable": false,
      "placeholder": "Selecione o tipo de relatório"
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', [_c('strong', [_vm._v(_vm._s(option.nome))]), _c('br'), _c('small', {
          staticClass: "text-muted"
        }, [_vm._v(_vm._s(option.descricao))])])];
      }
    }]),
    model: {
      value: _vm.tipoSelecionado,
      callback: function callback($$v) {
        _vm.tipoSelecionado = $$v;
      },
      expression: "tipoSelecionado"
    }
  })], 1)], 1), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Escola",
      "label-for": "select-escola",
      "label-class": "font-weight-bold"
    }
  }, [_c('v-select', {
    attrs: {
      "id": "select-escola",
      "options": _vm.escolas,
      "label": "name",
      "reduce": function reduce(escola) {
        return escola;
      },
      "loading": _vm.loadingEscolas,
      "placeholder": "Selecione a escola para gerar o relatório"
    },
    scopedSlots: _vm._u([{
      key: "no-options",
      fn: function fn() {
        return [_vm._v(" Nenhuma escola encontrada ")];
      },
      proxy: true
    }]),
    model: {
      value: _vm.escolaSelecionada,
      callback: function callback($$v) {
        _vm.escolaSelecionada = $$v;
      },
      expression: "escolaSelecionada"
    }
  })], 1)], 1)], 1), _c('b-row', {
    staticClass: "mt-50"
  }, [_c('b-col', {
    staticClass: "d-flex flex-wrap align-items-center justify-content-between",
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "d-flex align-items-center mb-1 mb-md-0"
  }, [_c('b-button', {
    staticClass: "mr-1 d-flex align-items-center",
    attrs: {
      "variant": "primary",
      "disabled": !_vm.escolaSelecionada || _vm.loadingGerando
    },
    on: {
      "click": _vm.gerarRelatorio
    }
  }, [_vm.loadingGerando ? _c('b-spinner', {
    staticClass: "mr-50",
    attrs: {
      "small": ""
    }
  }) : _c('feather-icon', {
    staticClass: "mr-50",
    attrs: {
      "icon": "PlayIcon",
      "size": "16"
    }
  }), _vm._v(" " + _vm._s(_vm.loadingGerando ? 'Gerando Relatório...' : 'Gerar Relatório') + " ")], 1), _vm.dadosRelatorio.length > 0 ? _c('b-button', {
    staticClass: "d-flex align-items-center",
    attrs: {
      "variant": "outline-success"
    },
    on: {
      "click": _vm.baixarExcel
    }
  }, [_c('feather-icon', {
    staticClass: "mr-50",
    attrs: {
      "icon": "DownloadIcon",
      "size": "16"
    }
  }), _vm._v(" Baixar Planilha (XLS) ")], 1) : _vm._e()], 1), _vm.relatorioGerado && _vm.escolaSelecionada ? _c('span', {
    staticClass: "text-muted small"
  }, [_vm._v(" Escola selecionada: "), _c('strong', [_vm._v(_vm._s(_vm.escolaSelecionada.name))])]) : _vm._e()])], 1)], 1)], 1), _vm.relatorioGerado && _vm.dadosRelatorio.length > 0 ? _c('b-row', {
    staticClass: "mb-2"
  }, [_c('b-col', {
    staticClass: "mb-1 mb-lg-0",
    attrs: {
      "sm": "6",
      "lg": "3"
    }
  }, [_c('b-card', {
    staticClass: "text-center shadow-none border mb-0"
  }, [_c('div', {
    staticClass: "avatar bg-light-primary p-50 mb-1 mx-auto"
  }, [_c('feather-icon', {
    staticClass: "text-primary",
    attrs: {
      "icon": "UsersIcon",
      "size": "24"
    }
  })], 1), _c('h3', {
    staticClass: "font-weight-bolder mb-25"
  }, [_vm._v(_vm._s(_vm.dadosRelatorio.length))]), _c('p', {
    staticClass: "card-text text-muted mb-0"
  }, [_vm._v("Estudantes no Relatório")])])], 1), _c('b-col', {
    staticClass: "mb-1 mb-lg-0",
    attrs: {
      "sm": "6",
      "lg": "3"
    }
  }, [_c('b-card', {
    staticClass: "text-center shadow-none border mb-0"
  }, [_c('div', {
    staticClass: "avatar bg-light-success p-50 mb-1 mx-auto"
  }, [_c('feather-icon', {
    staticClass: "text-success",
    attrs: {
      "icon": "CheckCircleIcon",
      "size": "24"
    }
  })], 1), _c('h3', {
    staticClass: "font-weight-bolder mb-25"
  }, [_vm._v(_vm._s(_vm.totalConcluiramQuatroMais))]), _c('p', {
    staticClass: "card-text text-muted mb-0"
  }, [_vm._v("Concluíram 4+ Desafios")])])], 1), _c('b-col', {
    staticClass: "mb-1 mb-lg-0",
    attrs: {
      "sm": "6",
      "lg": "3"
    }
  }, [_c('b-card', {
    staticClass: "text-center shadow-none border mb-0"
  }, [_c('div', {
    staticClass: "avatar bg-light-info p-50 mb-1 mx-auto"
  }, [_c('feather-icon', {
    staticClass: "text-info",
    attrs: {
      "icon": "ShieldIcon",
      "size": "24"
    }
  })], 1), _c('h3', {
    staticClass: "font-weight-bolder mb-25"
  }, [_vm._v(_vm._s(_vm.totalSolucoesPatrulha))]), _c('p', {
    staticClass: "card-text text-muted mb-0"
  }, [_vm._v("Soluções Patrulha Aprovadas")])])], 1), _c('b-col', {
    attrs: {
      "sm": "6",
      "lg": "3"
    }
  }, [_c('b-card', {
    staticClass: "text-center shadow-none border mb-0"
  }, [_c('div', {
    staticClass: "avatar bg-light-warning p-50 mb-1 mx-auto"
  }, [_c('feather-icon', {
    staticClass: "text-warning",
    attrs: {
      "icon": "ActivityIcon",
      "size": "24"
    }
  })], 1), _c('h3', {
    staticClass: "font-weight-bolder mb-25"
  }, [_vm._v(_vm._s(_vm.totalAcessosApp))]), _c('p', {
    staticClass: "card-text text-muted mb-0"
  }, [_vm._v("Acessos Totais ao App")])])], 1)], 1) : _vm._e(), _vm.relatorioGerado ? _c('b-card', {
    attrs: {
      "no-body": ""
    }
  }, [_c('b-card-header', {
    staticClass: "d-flex flex-wrap justify-content-between align-items-center py-1"
  }, [_c('div', [_c('h4', {
    staticClass: "card-title mb-25"
  }, [_vm._v("Prévia dos Dados")]), _c('span', {
    staticClass: "text-muted small"
  }, [_vm._v("Exibindo registros gerados para exportação")])]), _c('div', {
    staticClass: "d-flex align-items-center mt-1 mt-md-0"
  }, [_c('b-input-group', {
    staticClass: "input-group-merge mr-1",
    staticStyle: {
      "min-width": "260px"
    }
  }, [_c('b-input-group-prepend', {
    attrs: {
      "is-text": ""
    }
  }, [_c('feather-icon', {
    attrs: {
      "icon": "SearchIcon"
    }
  })], 1), _c('b-form-input', {
    attrs: {
      "placeholder": "Filtrar por estudante ou turma..."
    },
    model: {
      value: _vm.filtroBusca,
      callback: function callback($$v) {
        _vm.filtroBusca = $$v;
      },
      expression: "filtroBusca"
    }
  })], 1), _c('b-button', {
    staticClass: "d-flex align-items-center",
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.baixarExcel
    }
  }, [_c('feather-icon', {
    staticClass: "mr-50",
    attrs: {
      "icon": "DownloadIcon",
      "size": "14"
    }
  }), _vm._v(" Baixar XLS ")], 1)], 1)]), _c('b-table', {
    staticClass: "position-relative mb-0",
    attrs: {
      "items": _vm.dadosFiltrados,
      "fields": _vm.colunasTabela,
      "responsive": "",
      "striped": "",
      "hover": "",
      "show-empty": "",
      "empty-text": "Nenhum estudante encontrado para esta escola.",
      "current-page": _vm.paginaAtual,
      "per-page": _vm.itensPorPagina
    },
    scopedSlots: _vm._u([{
      key: "cell(codigoEstudante)",
      fn: function fn(data) {
        return [_c('span', {
          staticClass: "font-weight-bold text-primary"
        }, [_vm._v(_vm._s(data.value))])];
      }
    }, {
      key: "cell(turma)",
      fn: function fn(data) {
        return [_c('b-badge', {
          attrs: {
            "variant": "light-secondary"
          }
        }, [_vm._v(_vm._s(data.value))])];
      }
    }, {
      key: "cell(patrulhaPre)",
      fn: function fn(data) {
        return [_c('span', [_vm._v(_vm._s(data.value !== null ? data.value + ' pts' : '-'))])];
      }
    }, {
      key: "cell(patrulhaPos)",
      fn: function fn(data) {
        return [_c('span', [_vm._v(_vm._s(data.value !== null ? data.value + ' pts' : '-'))])];
      }
    }, {
      key: "cell(patrulhaResultado)",
      fn: function fn(data) {
        return [_c('b-badge', {
          attrs: {
            "variant": _vm.resolverVariacaoBadge(data.value)
          }
        }, [_vm._v(" " + _vm._s(data.value) + " ")])];
      }
    }, {
      key: "cell(janelaPre)",
      fn: function fn(data) {
        return [_c('span', [_vm._v(_vm._s(data.value !== null ? data.value + ' pts' : '-'))])];
      }
    }, {
      key: "cell(janelaPos)",
      fn: function fn(data) {
        return [_c('span', [_vm._v(_vm._s(data.value !== null ? data.value + ' pts' : '-'))])];
      }
    }, {
      key: "cell(janelaResultado)",
      fn: function fn(data) {
        return [_c('b-badge', {
          attrs: {
            "variant": _vm.resolverVariacaoBadge(data.value)
          }
        }, [_vm._v(" " + _vm._s(data.value) + " ")])];
      }
    }, {
      key: "cell(concluiuQuiz)",
      fn: function fn(data) {
        return [_c('b-badge', {
          attrs: {
            "variant": data.value === 'Sim' ? 'light-success' : 'light-secondary'
          }
        }, [_vm._v(" " + _vm._s(data.value) + " ")])];
      }
    }, {
      key: "cell(concluiuPatrulha)",
      fn: function fn(data) {
        return [_c('b-badge', {
          attrs: {
            "variant": data.value === 'Sim' ? 'light-success' : 'light-secondary'
          }
        }, [_vm._v(" " + _vm._s(data.value) + " ")])];
      }
    }, {
      key: "cell(concluiuJanela)",
      fn: function fn(data) {
        return [_c('b-badge', {
          attrs: {
            "variant": data.value === 'Sim' ? 'light-success' : 'light-secondary'
          }
        }, [_vm._v(" " + _vm._s(data.value) + " ")])];
      }
    }, {
      key: "cell(concluiuColeta)",
      fn: function fn(data) {
        return [_c('b-badge', {
          attrs: {
            "variant": data.value === 'Sim' ? 'light-success' : 'light-secondary'
          }
        }, [_vm._v(" " + _vm._s(data.value) + " ")])];
      }
    }, {
      key: "cell(concluiuArboturma)",
      fn: function fn(data) {
        return [_c('b-badge', {
          attrs: {
            "variant": data.value === 'Sim' ? 'light-success' : 'light-secondary'
          }
        }, [_vm._v(" " + _vm._s(data.value) + " ")])];
      }
    }, {
      key: "cell(concluiuQuatroOuMais)",
      fn: function fn(data) {
        return [_c('b-badge', {
          attrs: {
            "variant": data.value === 'Sim' ? 'success' : 'secondary'
          }
        }, [_vm._v(" " + _vm._s(data.value) + " ")])];
      }
    }], null, false, 3776760780)
  }), _c('b-card-footer', {
    staticClass: "d-flex justify-content-between align-items-center py-1"
  }, [_c('span', {
    staticClass: "text-muted small"
  }, [_vm._v(" Mostrando " + _vm._s(_vm.inicioRegistro) + " até " + _vm._s(_vm.fimRegistro) + " de " + _vm._s(_vm.dadosFiltrados.length) + " registros ")]), _c('b-pagination', {
    staticClass: "mb-0",
    attrs: {
      "total-rows": _vm.dadosFiltrados.length,
      "per-page": _vm.itensPorPagina,
      "first-number": "",
      "last-number": "",
      "prev-class": "prev-item",
      "next-class": "next-item"
    },
    model: {
      value: _vm.paginaAtual,
      callback: function callback($$v) {
        _vm.paginaAtual = $$v;
      },
      expression: "paginaAtual"
    }
  })], 1)], 1) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }